import { QueryClient } from '@tanstack/react-query';
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query';
import { routeTree } from './routeTree.gen';
import { createRouter as makeRouter } from '@tanstack/react-router';

export function getRouter() {
	const queryClient = new QueryClient();

	const router = makeRouter({
		routeTree,
		context: {
			queryClient,
		},
		defaultPreloadStaleTime: 0,
		defaultPreload: 'intent',
		defaultViewTransition: true,
		defaultNotFoundComponent: () => 'NOT FOUND',
	});

	setupRouterSsrQueryIntegration({
		router,
		queryClient,
	});

	return router;
}

declare module '@tanstack/react-router' {
	interface Register {
		router: ReturnType<typeof getRouter>;
	}
}
